// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71902175","239":"92a7f9df","667":"d235e75a"}[chunkId] + ".chunk.js";
};